import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

import router from './router'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

let app = "";

if (!app) {
  app = new Vue({
    el: "#app",
    router,
    vuetify,
    render: h => h(App),
  });
}